import React, { useState, useEffect } from "react";
import './SearchAskQuestionIndex.css'
import {
    iMSLogoTabletView, imsLoader
} from '../../assets/index';
import { Link } from 'react-router-dom';
import { useHistory } from "react-router";
import trackingService from "../../services/trackingService";
import FilterService from "../../services/FilterService";
import GenerateArrayStrings from "../GenerateArrayStrings";
import SuggestionAI from "../GenAIRecommendedHome/SuggestionAI";
import { Popover } from 'react-tiny-popover';
import { isShowAIMode, isShowAIOverview } from "../../utils/utilityServices"

export default function SearchAskQuestionIndexResult(props) {
    const [customWidth, setCustomWidth] = useState(props.customWidth);
    const [customHeight, setCustomHeight] = useState(props.customHeight);
    const [searchKeyword, setSearchKeyword] = useState(props.searchKeyword);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isClickOnSuggestion, setIsClickOnSuggestion] = useState(false);
    const [keyBoardEvent, setKeyBoardEvent] = useState(false);
    const [keyEventName, setkeyEventName] = useState("");
    const [showOptions, setShowOptions] = useState("");
    const [dropdownValue, setDropdownValue] = useState(props.dropdownValue);
    const [fieldedValue, setFieldedValue] = useState(props.fieldedValue);
    const [isDisableAIOverview, setIsDisableAIOverview] = useState(props.isDisableAIOverview);
    const [isDisableAIOverviewProcessing, setIsDisableAIOverviewProcessing] = useState(props.isDisableAIOverviewProcessing);


    useEffect(() => {
        setIsDisableAIOverview(props.isDisableAIOverview)
    }, [props.isDisableAIOverview]);

    useEffect(() => {
        setIsDisableAIOverviewProcessing(props.isDisableAIOverviewProcessing)
    }, [props.isDisableAIOverviewProcessing]);

    useEffect(() => {
        setDropdownValue(props.dropdownValue)
    }, [props.dropdownValue])

    useEffect(() => {
        setSearchKeyword(props.searchKeyword)
    }, [props.searchKeyword])
    const history = useHistory();
    const handleChangeInSearch = (event) => {
        setSearchKeyword(event.target.value);
        setShowSuggestions(true)
    }
    const handleChangeInDropdown = (event) => {
        //console.log(event.target.attributes.keyValue.value);
        let fieldedVal;
        event.preventDefault();
        if (event.target.attributes.keyvalue.value === "All Fields") {
            fieldedVal = "";
        } else if (event.target.attributes.keyvalue.value === "Author") {
            fieldedVal = "authors";
        } else if (event.target.attributes.keyvalue.value === "Congress") {
            fieldedVal = "fullCnSf";
        } else if (event.target.attributes.keyvalue.value === "Document Type") {
            fieldedVal = "docTypeSynonyms";
        } else if (event.target.attributes.keyvalue.value === "Title") {
            fieldedVal = "docTitle";
        } else if (event.target.attributes.keyvalue.value === "Publication Year") {
            fieldedVal = "strYear";
        } else if (event.target.attributes.keyvalue.value === "Journal Name") {
            fieldedVal = "journalName";
        } else if (event.target.attributes.keyvalue.value === "Document Number") {
            fieldedVal = "documentNumber";
        }
        setDropdownValue(event.target.attributes.keyvalue.value);
        setShowOptions(!showOptions);
        setFieldedValue(fieldedVal)
    };
    const handleKeyDown = async (event) => {
        // if (['Enter'].includes(event.key) && !event.shiftKey && searchKeyword && searchKeyword.trim()) {
        //     event.preventDefault();
        //     event.returnValue = false;
        //     await handleOnClickSearchIcon();
        // }

        if (["Enter"].includes(event.key)) {
            setShowSuggestions(false)
            let newUrl = buildUrl(
                event.target.value,
                dropdownValue,
                fieldedValue,
                props.appliedFilters
            );
            props.handleChangeInSearch(searchKeyword);
            history.push(newUrl);
            let str = createSearchCriteriaString();
            str = str.replace(/(")/g, '\\"');
            const ts = new trackingService();
            ts.indexTrackingData(
                localStorage.getItem("userdisplayName"),
                localStorage.getItem("wwid"),
                localStorage.getItem("username"),
                localStorage.getItem("function"),
                localStorage.getItem("region"),
                localStorage.getItem("userproducts"),
                localStorage.getItem("doctypepref"),
                localStorage.getItem("sid"),
                localStorage.getItem("deviceType"),
                localStorage.getItem("deviceOS"),
                localStorage.getItem("browserName"),
                localStorage.getItem("browserVersion"),
                localStorage.getItem("jnjDepartment"),
                localStorage.getItem("companyname"),
                "Conducted Search",
                "",
                newUrl,
                str,
                props.appliedFilters,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                props.csPath !== null ? props.csPath : "",
                props.csproduct !== null ? props.csproduct : ""
            );
        }
        if (["ArrowDown"].includes(event.key) || ["ArrowUp"].includes(event.key)) {

            setKeyBoardEvent(true)
            setkeyEventName(event.key)
        }
    }
    const buildUrl = (searchKeyword, dropdownValue, fieldedVal, filters) => {
        if (!fieldedVal) {
            if (dropdownValue === "All Fields") {
                fieldedVal = "";
            } else if (dropdownValue === "Author") {
                fieldedVal = "authors";
            } else if (dropdownValue === "Congress") {
                fieldedVal = "fullCnSf";
            } else if (dropdownValue === "Document Type") {
                fieldedVal = "docTypeSynonyms";
            } else if (dropdownValue === "Title") {
                fieldedVal = "docTitle";
            } else if (dropdownValue === "Publication Year") {
                fieldedVal = "strYear";
            } else if (dropdownValue === "Journal Name") {
                fieldedVal = "journalName";
            } else if (dropdownValue === "Document Number") {
                fieldedVal = "documentNumber";
            }
        }
        searchKeyword = encodeURIComponent(searchKeyword);
        if (history.location.pathname === "/viewReadingList" || window.location.pathname === '/old_viewReadingList' || history.location.pathname === "/GenAIViewReadingList") {
            let paramsForviewResult = new URLSearchParams(
                history.location.search
            );
            let q = paramsForviewResult.get("q");
            let filters = paramsForviewResult.get("filters");
            let f1 = paramsForviewResult.get("f1");
            let fval1 = paramsForviewResult.get("fval1");
            let fcount = paramsForviewResult.get("fcount");
            let rName = paramsForviewResult.get("rName");
            let rID = paramsForviewResult.get("rID");
            return `${history.location.pathname}?query=${searchKeyword}&q=${q}&filters=${filters}&f1=${f1}&fval1=${fval1}&fcount=${fcount}&rName=${rName}&rID=${rID}`;
        } else {

            let params = new URLSearchParams(history.location.search);
            let csPath = params.get("cspath");
            let csproduct = params.get("csproduct");
            let andFields = params.get("andFields");
            let orFields = params.get("orFields");
            let docTitle = params.get("docTitle");
            let authors = params.get("authors");
            let majorTopicsSynonyms = params.get("majorTopicsSynonyms");
            let FS = params.get("FS");
            let fromYear = params.get("fromYear");
            let toYear = params.get("toYear");
            let sbQuery = params.get("sbQuery");
            let f1 = params.get("f1");
            let isDateRange = params.get("isDateRange");
            let rangeField = params.get("rangeField");
            let toRange = params.get("toRange");
            let fromRange = params.get("fromRange");
            let filterStr = GenerateArrayStrings(filters);
            filterStr = encodeURIComponent(filterStr);
            let fcount = params.get("fcount");
            let fval1 = params.get("fval1");
            let q = params.get("q");
            let queryType = params.get("queryType");
            let isDisableAiOverview = params.get("isDisableAiOverview");
            let url = ``;
            let isDropdownValueChange = q !== dropdownValue;
            if (
                searchKeyword === undefined ||
                dropdownValue === undefined ||
                filters === undefined
            ) {
                url = `/results?query=&q=&filters=`;
            } else if (
                csPath !== null &&
                csproduct !== null &&
                searchKeyword !== ""
            ) {
                let query = searchKeyword;
                let oldQuery = params.get("query");
                if (
                    params.get("fval1") !== null &&
                    query.toLowerCase().includes(params.get("fval1").toLowerCase())
                ) {
                    let fcount = parseInt(params.get("fcount"));
                    let fvalStr = "";
                    for (let i = 1; i <= fcount; i++) {
                        fvalStr =
                            fvalStr +
                            `&f${i}=${params.get(`f${i}`)}&fval${i}=${params.get(
                                `fval${i}`
                            )}`;
                    }
                    if (sbQuery !== null) {
                        let newSbQuery = query.replace(oldQuery, sbQuery);
                        url =
                            `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}${fvalStr}` +
                            `&fcount=${fcount}&sbQuery=${newSbQuery}` +
                            `&cspath=${csPath}&csproduct=${csproduct}`;
                    } else {
                        url =
                            `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}${fvalStr}` +
                            `&fcount=${fcount}` +
                            `&cspath=${csPath}&csproduct=${csproduct}`;
                    }
                } else {
                    url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}`;
                }
            } else if (
                f1 !== null &&
                fval1 !== null &&
                searchKeyword !== "" &&
                csPath === null &&
                csproduct === null &&
                f1 === "tempJNJDrugs"
            ) {
                if (searchKeyword.toLowerCase().includes(fval1.toLowerCase())) {
                    if (fieldedVal === "") {
                        fieldedVal = f1;
                    }
                    url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}&f1=${fieldedVal}&fval1=${fval1}&fcount=1&sbQuery=${searchKeyword}`;
                } else {
                    url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}`;
                }
            }
            //&& (fcount && isDropdownValueChange)
            else if (
                dropdownValue === "All Fields" &&
                !FS &&
                (!fcount || isDropdownValueChange) &&
                !window.isSupportingDocs
            ) {
                url = `/results?query=${searchKeyword}&q=All Fields&filters=${filterStr}`;
            } else if (searchKeyword === "" && !FS && !window.isSupportingDocs) {
                url = `/results?query=&q=All Fields&filters=${filterStr}`;
            } else if (window.isSupportingDocs) {
                url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}`;
                let reFCount = 0;
                if (f1 && fval1) {
                    reFCount++;
                    url += `&f1=${f1}&fval1=${fval1}`;
                } else {
                    window.isSupportingDocs = undefined;
                }
                if (dropdownValue !== "All Fields" && searchKeyword) {
                    reFCount++;
                    url += `&f${reFCount}=${fieldedVal}&fval${reFCount}=${searchKeyword}`;
                }
                url += `&fcount=${reFCount}&sbQuery=${dropdownValue !== "All Fields" ? "" : searchKeyword
                    }`;
            } else {
                if (FS) {
                    url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}`;
                    let DS = params.get("DS");
                    let previousFKey = "";
                    let previousFValue = "";
                    //if (fieldedVal === "docTypeSynonyms") fieldedVal = "docType";
                    if (DS) {
                        let DSSplit = DS.split("ǂ");
                        if (DSSplit.length === 2) {
                            previousFKey = DSSplit[0];
                            previousFValue = encodeURIComponent(DSSplit[1]);
                        }
                    }
                    let isKeyAvailable = false;
                    let reFcount = 0;
                    if (!fcount) fcount = 0;
                    for (let i = 1; i <= fcount; i++) {
                        let key = params.get(`f${i}`);
                        let value = encodeURIComponent(params.get(`fval${i}`));
                        if (key === previousFKey) {
                            let splitValue = value.split(";");
                            splitValue = splitValue.filter((x) => x && x !== previousFValue);
                            value = splitValue.join(";");
                        }
                        // if (key === fieldedVal) {
                        //   let splitValue = value.split(";");
                        //   splitValue = splitValue.filter(x => x && x !== previousFValue && x !== searchKeyword);
                        //   if (searchKeyword) {
                        //     splitValue.push(searchKeyword)
                        //   }
                        //   value = splitValue.join(";");
                        //   isKeyAvailable = true;
                        // }
                        if (value) {
                            reFcount++;
                            url += `&f${reFcount}=${key}&fval${reFcount}=${value}`;
                        }
                    }
                    if (!isKeyAvailable && searchKeyword && fieldedVal) {
                        reFcount++;
                        url += `&f${reFcount}=${fieldedVal}&fval${reFcount}=${searchKeyword}`;
                    }
                    url += `&fcount=${reFcount}`;
                    if (searchKeyword && fieldedVal) {
                        url += `&DS=${fieldedVal}ǂ${searchKeyword}`;
                    }
                } else {
                    if (fieldedVal === "") {
                        fieldedVal = f1;
                    }
                    url = `/results?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}&f1=${fieldedVal}&fval1=${searchKeyword}&fcount=1&sbQuery=${dropdownValue !== "All Fields" ? "" : searchKeyword
                        }`;
                }
            }
            if (FS) {
                if (andFields !== "" && andFields !== null) {
                    url += `&andFields=${andFields}`;
                }
                if (orFields !== "" && orFields !== null) {
                    url += `&orFields=${orFields}`;
                }
                if (docTitle !== "" && docTitle !== null) {
                    url += `&docTitle=${encodeURIComponent(docTitle)}`;
                }
                if (authors !== "" && authors !== null) {
                    url += `&authors=${encodeURIComponent(authors)}`;
                }
                if (majorTopicsSynonyms !== "" && majorTopicsSynonyms !== null) {
                    url += `&majorTopicsSynonyms=${encodeURIComponent(
                        majorTopicsSynonyms
                    )}`;
                }
                if (fromYear !== "" && fromYear !== null) {
                    url += `&fromYear=${fromYear}`;
                }
                if (toYear !== "" && toYear !== null) {
                    url += `&toYear=${toYear}`;
                }
                url += `&FS=true`;
                //if (dropdownValue && dropdownValue !== "All Fields") 
                url += `&sbQuery=`;

            }
            if (isDateRange && rangeField && (fromRange || toRange)) {
                url = url + `&isDateRange=Yes&rangeField=modifiedDate`;
                if (fromRange) {
                    url = url + `&fromRange=${fromRange}`;
                }
                if (toRange) {
                    url = url + `&toRange=${toRange}`;
                }
            }
            if (queryType) {
                url += `&queryType=alerts`;
            }
            if (isClickOnSuggestion) {
                url += `&isClickOnSuggestion=true`;
            }
            if (isDisableAiOverview) {
                url += `&isDisableAiOverview=true`;
            }
            if (history.location.pathname === "/Overview") {
                url = url.replace("/results?", "/Overview?")
            }
            return url;
        }
    };
    const createSearchCriteriaString = () => {
        const queryParams = new URLSearchParams(document.location.search);
        const params = queryParams.get("query");
        const filters = queryParams.get("filters");
        const q = queryParams.get("q");
        const fcount = queryParams.get("fcount");
        const majorTopicsSynonyms = queryParams.get("majorTopicsSynonyms");
        const authors = queryParams.get("authors");
        const docTitle = queryParams.get("docTitle");
        let str = "";
        let fieldedSearch = queryParams.get("FS");
        let rlName = queryParams.get("rName");
        let limistArr = [];
        let f1 = "", fval1 = "";

        if (window.location.pathname !== "/ReferencesUsed") {
            if (fcount && fcount > 0) {
                f1 = queryParams.get("f1");
                fval1 = queryParams.get("fval1");
            }
            if ((f1 && (f1 === "tempJNJDrugs" || f1 === "taIRO")) &&
                params !== "" &&
                filters !== "" &&
                q !== "All Fields" &&
                !fieldedSearch
            ) {
                if (f1 === "tempJNJDrugs") {
                    str = `(Products: ${fval1}): ${q}: ${params}: ${filters}`;
                } else {
                    str = `(Therapeutic Area: ${fval1}): ${q}: ${params}: ${filters}`;
                }
            }
            else if ((f1 && (f1 === "tempJNJDrugs" || f1 === "taIRO")) && params !== "" &&
                filters !== "" &&
                q === "All Fields" &&
                !fieldedSearch) {
                if (f1 === "tempJNJDrugs") {
                    str = `(Products: ${fval1}): ${params}: ${filters}`;
                } else {
                    str = `(Therapeutic Area: ${fval1}): ${params}: ${filters}`;
                }
            }
            else if ((f1 && (f1 === "tempJNJDrugs" || f1 === "taIRO")) &&
                params !== "" &&
                filters === "" &&
                q === "All Fields" &&
                !fieldedSearch
            ) {
                if (f1 === "tempJNJDrugs") {
                    str = `(Products: ${fval1}): ${params}`;
                } else {
                    str = `(Therapeutic Area: ${fval1}): ${params}`;
                }
            } else if ((f1 && (f1 === "tempJNJDrugs" || f1 === "taIRO")) &&
                params !== "" &&
                filters === "" &&
                q !== "All Fields" &&
                !fieldedSearch
            ) {
                if (f1 === "tempJNJDrugs") {
                    str = `(Products: ${fval1}): ${q}: ${params}`;
                } else {
                    str = `(Therapeutic Area: ${fval1}): ${q}: ${params}`;
                }
            }
            else if (
                params !== "" &&
                filters !== "" &&
                q !== "All Fields" &&
                !fieldedSearch
            ) {
                str = `${q}: ${params}: ${filters}`;
            }
            else if (
                params !== "" &&
                filters !== "" &&
                q === "All Fields" &&
                !fieldedSearch
            ) {
                str = `${params}: ${filters}`;
            } else if (
                params !== "" &&
                filters === "" &&
                q === "All Fields" &&
                !fieldedSearch
            ) {
                str = `${params}`;
            } else if (
                params !== "" &&
                filters === "" &&
                q !== "All Fields" &&
                !fieldedSearch
            ) {
                str = `${q}: ${params}`;
            } else if (fieldedSearch) {
                // Publication Year
                let toRange = queryParams.get("toYear");
                let fromRange = queryParams.get("fromYear");
                let PublicationYear = "";
                if (toRange) {
                    toRange = parseInt(toRange);
                }
                if (fromRange) {
                    fromRange = parseInt(fromRange);
                }
                let strYear = limistArr.find((x) => x.key === "strYear");
                if (strYear) {
                    let strYearValue = parseInt(strYear.value);
                    if (
                        toRange &&
                        fromRange &&
                        fromRange <= strYearValue &&
                        toRange >= strYearValue
                    ) {
                        PublicationYear = `${fromRange} To ${toRange}`;
                    } else if (
                        toRange &&
                        fromRange &&
                        (fromRange > strYearValue || toRange < strYearValue)
                    ) {
                        PublicationYear = `${fromRange} To ${toRange} AND ${strYearValue}`;
                    } else if (toRange && strYearValue) {
                        PublicationYear = `${toRange} and earlier AND ${strYearValue}`;
                    } else if (fromRange && strYearValue) {
                        PublicationYear = `${fromRange} and later AND ${strYearValue}`;
                    } else if (strYearValue) {
                        PublicationYear = `${strYearValue}`;
                    }
                } else if (toRange && fromRange) {
                    PublicationYear = `${fromRange} To ${toRange}`;
                } else if (toRange) {
                    PublicationYear = `${toRange} and earlier`;
                } else if (fromRange) {
                    PublicationYear = `${fromRange} and later`;
                }
                limistArr = limistArr.filter((x) => x.key !== "strYear");
                ///////
                let fcount = queryParams.get("fcount");
                for (let i = 0; i < fcount; i++) {
                    let key = queryParams.get(`f${i + 1}`);
                    let value = queryParams.get(`fval${i + 1}`);
                    limistArr[i] = { key: key, value: value };
                }

                str = params ? `(${params}) ${filters ? ":" + filters : ""}` : "";

                if (!params && params === "" && filters !== "" && filters !== null) {
                    str = str + `${filters ? filters : ""}`;
                }

                str = str + (docTitle ? ` (Title: ${docTitle})` : "");
                str = str + (authors ? ` (Authors: ${authors})` : "");
                str =
                    str +
                    (majorTopicsSynonyms
                        ? ` (Major Topics: ${majorTopicsSynonyms})`
                        : "");
                str =
                    str +
                    (PublicationYear ? ` (Publication Year: ${PublicationYear})` : "");
                if (fcount > 0 && limistArr.length > 0) {
                    limistArr.map((item, index) => {
                        str =
                            str +
                            (item.key
                                ? ` (${conversionOfFieldType(item.key)}: ${item.value})`
                                : "");
                    });
                }
            }

            if (window.supportingDocsSearchStrategyDescription) {
                let searchDes = window.supportingDocsSearchStrategyDescription;
                if (str) {
                    str = searchDes + `, ${str}`;
                }
            }
            if (rlName) {
                str = `${rlName}ǂ$±@${str}`;
            }
            return str;
        }
    }
    const conversionOfFieldType = (item) => {
        if (item === "docType" || item === "docTypeSynonyms")
            return "Document Type";
        else if (item === "protocolIDs" || item === "harmonizedProtocolIDs") return "Protocol Number";
        else if (item === "genericName") return "Generic Name";
        else if (item === "congressName" || item === "fullCnSf")
            return "Congress Name";
        else if (item === "strYear") return "Publication Year";
        else if (item === "authors") return "Author";
        else if (item === "docTitle") return "Title";
        else if (item === "documentNumber") return "Document Number";
        else return "Journal Name";
    };
    const handleOnClickSearchIcon = (searchKeyword) => {
        const queryParams = new URLSearchParams(window.location.search);
        const shouldResetGMAFFilters = queryParams.has("GMAFfilters");
        const gmafFilterPath =
            "Document Type/Global Medical Affairs Resources";
        const isGMAFFilter = (filter) =>
            filter === gmafFilterPath || filter.startsWith(`${gmafFilterPath}/`);
        const filterService = new FilterService();
        const shouldKeepFilter = (filter) =>
            !isGMAFFilter(filter) ||
            filterService.filterExists(props.allFilters, filter);
        const submittedAppliedFilters = shouldResetGMAFFilters
            ? props.appliedFilters.filter(shouldKeepFilter)
            : props.appliedFilters;

        if (searchKeyword === "") {
            setDropdownValue("All Fields");
        }
        const newUrl = buildUrl(
            searchKeyword,
            dropdownValue,
            fieldedValue,
            submittedAppliedFilters
        );
        props.handleChangeInSearch(searchKeyword, submittedAppliedFilters);
        history.push(newUrl);
        let str = createSearchCriteriaString();
        str = str.replace(/(")/g, '\\"');
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            "Conducted Search",
            "",
            newUrl,
            str,
            submittedAppliedFilters,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            props.csPath !== null ? props.csPath : "",
            props.csproduct !== null ? props.csproduct : ""
        );
        setKeyBoardEvent(false);
        setkeyEventName("");
        setShowSuggestions(false);
    };
    const onClickCancel = () => {
        setSearchKeyword("")
        props.handleClearSearch();
    }
    const handleAIMode = () => {
        props.handleAIMode(searchKeyword);
        // setKeyBoardEvent(false)
        // setKeyEventName('')
    }
    const handleOnChange = (query, fieldParam) => {
        setSearchKeyword(query);
        setShowSuggestions(false);
        handleOnClickSearchIcon(query);
    };
    const handleOnClickIsDisableAIOverview = async () => {
        setIsDisableAIOverviewProcessing(true);
        props.handleOnClickIsDisableAIOverview();

        // const services = new ApiServices();
        // let wwid = UserData.sub;
        // var response = await services.updateIsDisableAIOverview(wwid, !isDisableAIOverview);
        // await getUserIsDisableAIOverview();
    }
    if (customWidth < 600) {
        return (
            <div className="genAIRecommended-main-ask-question-wrapper-result-mobile">
                <div className="genAIRecommended-main-ask-question-Imedical-icon-mobile" >
                    <img src={iMSLogoTabletView} alt="iMedical Search" height={40} />
                </div>
                <div className="genAIRecommended-main-input-box-wrapper-result-mobile">
                    <span className="genAIRecommended-main-icon-wrapper-result-mobile">
                        <span className="genAIRecommended-main-search-icon-wrapper-webView-result-mobile">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="magnifying-glass" className="svg-inline--fa fa-magnifying-glass-result" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" >
                                <path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>
                            </svg>
                        </span>
                    </span>
                    <input name="searchBar" placeholder="Ask your question..." className="genAIRecommended-main-input-search-box-result-mobile" title="What are you looking for?" value={searchKeyword} onChange={handleChangeInSearch} onKeyDown={handleKeyDown} autoComplete="off" />
                </div>
            </div>)
    }

    else if (customWidth >= 600 && customWidth <= 1000) {
        return (
            <div className="genAIRecommended-main-ask-question-wrapper-result-tablets">
                {/* Search Input Row - Compact */}
                <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                    <div className="genAIRecommended-main-input-box-wrapper-result"
                        onMouseLeave={() => { setShowSuggestions(false) }}
                        style={{ flex: 1, position: "relative" }}>
                        <input name="searchBar" placeholder="Search..." className="genAIRecommended-main-input-search-box-result" title="What are you looking for?" value={searchKeyword} onChange={handleChangeInSearch} onKeyDown={handleKeyDown} autoComplete="off" style={{ padding: "8px 12px", fontSize: "14px" }} />
                        <button style={(searchKeyword && searchKeyword.length > 0) ? { visibility: "visible" } : { visibility: "hidden" }} type="button" className="genAIRecommended-cancel-button-ai-mode" onClick={onClickCancel}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5 5.5L5.5 16.5M5.5 5.5L16.5 16.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button type="button" className="genAIRecommended-search-button-ai-mode" onClick={(e) => { handleOnClickSearchIcon(searchKeyword) }}>
                            <svg fill="#ffffff" width="28" height="28" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-117.76 -117.76 747.52 747.52" enable-background="new 0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="0.00512">
                                <g id="SVGRepo_bgCarrier" stroke-width="0">
                                    <rect x="-117.76" y="-117.76" width="747.52" height="747.52" rx="373.76" fill="#EB1700" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M325.8,0C223,0,139.6,83.4,139.6,186.2c0,33.5,9,64.8,24.4,92L0,442.2l23.3,46.5L69.8,512l164-164 c27.1,15.5,58.5,24.4,92,24.4C428.6,372.4,512,289,512,186.2S428.6,0,325.8,0z M325.8,314.2c-70.7,0-128-57.3-128-128 c0-70.7,57.3-128,128-128s128,57.3,128,128C453.8,256.9,396.5,314.2,325.8,314.2z"></path>
                                </g>
                            </svg>
                        </button>
                        {(searchKeyword && searchKeyword.length > 2) && <div className="genAIRecommended-main-suggestion-box-outer">
                            <SuggestionAI
                                isFromResultPage={true}
                                searchKeyword={searchKeyword}
                                showSuggestions={showSuggestions}
                                handleOnChange={handleOnChange}
                                keyBoardEvent={keyBoardEvent}
                                keyEventName={keyEventName}
                                setKeyBoardEvent={() => { setKeyBoardEvent(false) }} />
                        </div>}
                    </div>


                    {/* AI Mode Button - Centered */}
                    {isShowAIMode() && <button type="button" className="genAIRecommended-main-button-ai-mode-result" onClick={(e) => { handleAIMode() }}  >
                        <div className="segment-control" style={{ height: '85%' }}>
                            <div className="segment-content">
                                <div className="segment-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.62479 10.3334C6.56527 10.1026 6.44502 9.89209 6.27653 9.72361C6.10805 9.55513 5.8975 9.43488 5.66679 9.37536L1.57679 8.32069C1.50701 8.30088 1.4456 8.25886 1.40186 8.20099C1.35813 8.14312 1.33447 8.07256 1.33447 8.00002C1.33447 7.92749 1.35813 7.85693 1.40186 7.79906C1.4456 7.74119 1.50701 7.69916 1.57679 7.67936L5.66679 6.62402C5.89742 6.56456 6.10792 6.44441 6.27639 6.27605C6.44486 6.10769 6.56517 5.89728 6.62479 5.66669L7.67946 1.57669C7.69906 1.50664 7.74105 1.44492 7.799 1.40095C7.85696 1.35699 7.92771 1.33319 8.00046 1.33319C8.0732 1.33319 8.14395 1.35699 8.20191 1.40095C8.25987 1.44492 8.30185 1.50664 8.32146 1.57669L9.37546 5.66669C9.43497 5.8974 9.55523 6.10795 9.72371 6.27644C9.89219 6.44492 10.1027 6.56517 10.3335 6.62469L14.4235 7.67869C14.4938 7.69809 14.5558 7.74003 14.6 7.79807C14.6442 7.85612 14.6682 7.92706 14.6682 8.00002C14.6682 8.07298 14.6442 8.14393 14.6 8.20197C14.5558 8.26002 14.4938 8.30196 14.4235 8.32136L10.3335 9.37536C10.1027 9.43488 9.89219 9.55513 9.72371 9.72361C9.55523 9.89209 9.43497 10.1026 9.37546 10.3334L8.32079 14.4234C8.30118 14.4934 8.2592 14.5551 8.20124 14.5991C8.14328 14.6431 8.07254 14.6669 7.99979 14.6669C7.92704 14.6669 7.85629 14.6431 7.79834 14.5991C7.74038 14.5551 7.69839 14.4934 7.67879 14.4234L6.62479 10.3334Z" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13.3335 2V4.66667" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.6667 3.33331H12" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.6665 11.3333V12.6666" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.33333 12H2" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div className="segment-label">AI Mode</div>
                            </div>
                        </div>
                    </button>}
                </div>
                {/* Filter and Options Row - Below textbox */}
                <div className="gen-ai-result-all-fields-and-options-row">
                    {/* Dropdown */}
                    <div className="genAIRecommended-main-dropdown genAIRecommended-main-searchSelect">
                        <Popover
                            isOpen={showOptions}
                            positions={['bottom', 'left']}
                            align={'center'}
                            containerClassName="react-tiny-popover-container"
                            containerStyle={{ top: '0px' }}
                            onClickOutside={(e) => {
                                if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                    setShowOptions(false);
                                }
                            }}
                            content={(positions, align) => (
                                <ul className="allFieldsListing genAIRecommended-main-searchSelect-allFieldsListing">
                                    {dropdownValue === "All Fields" ? null : (
                                        <li keyvalue="All Fields" onClick={handleChangeInDropdown}>All Fields</li>
                                    )}
                                    {dropdownValue === "Author" ? null : (
                                        <li keyvalue="Author" onClick={handleChangeInDropdown}>Author</li>
                                    )}
                                    {dropdownValue === "Congress" ? null : (
                                        <li keyvalue="Congress" onClick={handleChangeInDropdown}>Congress</li>
                                    )}
                                    {dropdownValue === "Document Type" ? null : (
                                        <li keyvalue="Document Type" onClick={handleChangeInDropdown}>Document Type</li>
                                    )}
                                    {dropdownValue === "Title" ? null : (
                                        <li keyvalue="Title" onClick={handleChangeInDropdown}>Title</li>
                                    )}
                                    {dropdownValue === "Publication Year" ? null : (
                                        <li keyvalue="Publication Year" onClick={handleChangeInDropdown}>Publication Year</li>
                                    )}
                                    {dropdownValue === "Journal Name" ? null : (
                                        <li keyvalue="Journal Name" onClick={handleChangeInDropdown}>Journal Name</li>
                                    )}
                                    {dropdownValue === "Document Number" ? null : (
                                        <li keyvalue="Document Number" onClick={handleChangeInDropdown}>Document Number</li>
                                    )}
                                </ul>
                            )}>
                            <button type="button" className={showOptions ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(!showOptions); }} style={{ fontSize: "13px" }}>
                                <svg style={showOptions ? {} : { transform: "matrix(-1, 0, 0, -1, 0, 0)" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Triangle" width="16" height="16">
                                    <path d="M4 24h24L16 6z" fill="#212121" class="color000000 svgShape"></path>
                                </svg>
                                <div className="genAIRecommended-main-title genAIRecommended-main-icon-title-all-fields">{dropdownValue}</div>
                            </button>
                        </Popover>
                    </div>

                    {/* Document Search Only Checkbox */}
                    <div className="gen-ai-result-disable-ai-overview">
                        {isShowAIOverview() && window.location.pathname === '/results' && <>
                            <div className="genAIRecommended-main-disable-ai-overview-classSection">
                                {isDisableAIOverviewProcessing ? <img
                                    src={imsLoader}
                                    alt="Loading Data"
                                    style={{ height: "18px" }}
                                /> : <><input
                                    type="checkbox"
                                    id={`isDisableAIOverview`}
                                    value="isDisableAIOverview"
                                    name="classCheckBox"
                                    className="cname"
                                    onChange={handleOnClickIsDisableAIOverview}
                                    checked={isDisableAIOverview}
                                    class="k-checkbox"
                                    style={{ margin: "0px" }}
                                />
                                    <span onClick={handleOnClickIsDisableAIOverview} className="genAIRecommended-main-title">Document Search Only</span></>}
                            </div>
                            <div style={{ visibility: "hidden", width: "110px" }} >&nbsp;</div>
                        </>}
                    </div>
                </div>
            </div>
        )
    }
    else if (customWidth > 1000) {
        return (
            <div className="genAIRecommended-main-ask-question-wrapper-result" >
                <div className="gen-ai-result-all-fields-and-inputbox-wrapper">
                    <div className="genAIRecommended-main-input-box-wrapper-result"
                        onMouseLeave={() => { setShowSuggestions(false) }}>
                        <input name="searchBar" placeholder="Search..." className="genAIRecommended-main-input-search-box-result" title="What are you looking for?" value={searchKeyword} onChange={handleChangeInSearch} onKeyDown={handleKeyDown} autoComplete="off" />
                        <button style={(searchKeyword && searchKeyword.length > 0) ? { visibility: "visible" } : { visibility: "hidden" }} type="button" className="genAIRecommended-cancel-button-ai-mode" onClick={onClickCancel}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5 5.5L5.5 16.5M5.5 5.5L16.5 16.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button type="button" className="genAIRecommended-search-button-ai-mode" onClick={(e) => { handleOnClickSearchIcon(searchKeyword) }}>
                            {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M19.25 19.25L13.7501 13.75M15.5833 9.16667C15.5833 12.7105 12.7105 15.5833 9.16667 15.5833C5.62284 15.5833 2.75 12.7105 2.75 9.16667C2.75 5.62284 5.62284 2.75 9.16667 2.75C12.7105 2.75 15.5833 5.62284 15.5833 9.16667Z" stroke="#eb1600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> */}
                            <svg fill="#ffffff" width="32" height="32" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-117.76 -117.76 747.52 747.52" enable-background="new 0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="0.00512">
                                <g id="SVGRepo_bgCarrier" stroke-width="0">
                                    <rect x="-117.76" y="-117.76" width="747.52" height="747.52" rx="373.76" fill="#EB1700" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M325.8,0C223,0,139.6,83.4,139.6,186.2c0,33.5,9,64.8,24.4,92L0,442.2l23.3,46.5L69.8,512l164-164 c27.1,15.5,58.5,24.4,92,24.4C428.6,372.4,512,289,512,186.2S428.6,0,325.8,0z M325.8,314.2c-70.7,0-128-57.3-128-128 c0-70.7,57.3-128,128-128s128,57.3,128,128C453.8,256.9,396.5,314.2,325.8,314.2z"></path>
                                </g>
                            </svg>
                        </button>
                        {(searchKeyword && searchKeyword.length > 2) && <div className="genAIRecommended-main-suggestion-box-outer">
                            <SuggestionAI
                                isFromResultPage={true}
                                searchKeyword={searchKeyword}
                                showSuggestions={showSuggestions}
                                handleOnChange={handleOnChange}
                                keyBoardEvent={keyBoardEvent}
                                keyEventName={keyEventName}
                                setKeyBoardEvent={() => { setKeyBoardEvent(false) }} />
                        </div>}
                    </div>
                    {isShowAIMode() && <button type="button" className="genAIRecommended-main-button-ai-mode-result" onClick={(e) => { handleAIMode() }}  >
                        <div className="segment-control" style={{ height: '85%' }}>
                            <div className="segment-content">
                                <div className="segment-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.62479 10.3334C6.56527 10.1026 6.44502 9.89209 6.27653 9.72361C6.10805 9.55513 5.8975 9.43488 5.66679 9.37536L1.57679 8.32069C1.50701 8.30088 1.4456 8.25886 1.40186 8.20099C1.35813 8.14312 1.33447 8.07256 1.33447 8.00002C1.33447 7.92749 1.35813 7.85693 1.40186 7.79906C1.4456 7.74119 1.50701 7.69916 1.57679 7.67936L5.66679 6.62402C5.89742 6.56456 6.10792 6.44441 6.27639 6.27605C6.44486 6.10769 6.56517 5.89728 6.62479 5.66669L7.67946 1.57669C7.69906 1.50664 7.74105 1.44492 7.799 1.40095C7.85696 1.35699 7.92771 1.33319 8.00046 1.33319C8.0732 1.33319 8.14395 1.35699 8.20191 1.40095C8.25987 1.44492 8.30185 1.50664 8.32146 1.57669L9.37546 5.66669C9.43497 5.8974 9.55523 6.10795 9.72371 6.27644C9.89219 6.44492 10.1027 6.56517 10.3335 6.62469L14.4235 7.67869C14.4938 7.69809 14.5558 7.74003 14.6 7.79807C14.6442 7.85612 14.6682 7.92706 14.6682 8.00002C14.6682 8.07298 14.6442 8.14393 14.6 8.20197C14.5558 8.26002 14.4938 8.30196 14.4235 8.32136L10.3335 9.37536C10.1027 9.43488 9.89219 9.55513 9.72371 9.72361C9.55523 9.89209 9.43497 10.1026 9.37546 10.3334L8.32079 14.4234C8.30118 14.4934 8.2592 14.5551 8.20124 14.5991C8.14328 14.6431 8.07254 14.6669 7.99979 14.6669C7.92704 14.6669 7.85629 14.6431 7.79834 14.5991C7.74038 14.5551 7.69839 14.4934 7.67879 14.4234L6.62479 10.3334Z" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13.3335 2V4.66667" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.6667 3.33331H12" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.6665 11.3333V12.6666" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.33333 12H2" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div className="segment-label">AI Mode</div>
                            </div>
                        </div>
                    </button>}
                </div>
                <div className="gen-ai-result-all-fields-dropdown-disable-ai-overview">
                    <div
                        className="genAIRecommended-main-dropdown genAIRecommended-main-searchSelect"
                    // onMouseLeave={this.handleCategoryClose}
                    >
                        <Popover
                            isOpen={showOptions}
                            positions={"bottom"}
                            align={'center'}
                            containerClassName="react-tiny-popover-container"
                            // scrollable
                            containerStyle={{
                                top: '100px',
                            }}
                            onClickOutside={(e) => {
                                if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                    setShowOptions(false);
                                }
                            }}
                            content={(positions, align) => (
                                <ul className="allFieldsListing genAIRecommended-main-searchSelect-allFieldsListing">
                                    {dropdownValue === "All Fields" ? null : (
                                        <li
                                            keyvalue="All Fields"
                                            onClick={handleChangeInDropdown}
                                        >
                                            All Fields
                                        </li>
                                    )}
                                    {dropdownValue === "Author" ? null : (
                                        <li
                                            keyvalue="Author"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Author
                                        </li>
                                    )}
                                    {dropdownValue === "Congress" ? null : (
                                        <li
                                            keyvalue="Congress"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Congress
                                        </li>
                                    )}
                                    {dropdownValue === "Document Type" ? null : (
                                        <li
                                            keyvalue="Document Type"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Document Type
                                        </li>
                                    )}
                                    {dropdownValue === "Title" ? null : (
                                        <li
                                            keyvalue="Title"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Title
                                        </li>
                                    )}
                                    {dropdownValue === "Publication Year" ? null : (
                                        <li
                                            keyvalue="Publication Year"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Publication Year
                                        </li>
                                    )}
                                    {dropdownValue === "Journal Name" ? null : (
                                        <li
                                            keyvalue="Journal Name"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Journal Name
                                        </li>
                                    )}
                                    {dropdownValue === "Document Number" ? null : (
                                        <li
                                            keyvalue="Document Number"
                                            onClick={handleChangeInDropdown}
                                        >
                                            Document Number
                                        </li>
                                    )}
                                </ul>
                            )}>
                            <button type="button" className={showOptions ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(!showOptions); }}>
                                <svg style={showOptions ? {} : { transform: "matrix(-1, 0, 0, -1, 0, 0)" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Triangle" width="17" height="17">
                                    <path d="M4 24h24L16 6z" fill="#212121" class="color000000 svgShape"> </path>
                                </svg>
                                <div className="genAIRecommended-main-title genAIRecommended-main-icon-title-all-fields">{dropdownValue}</div>
                            </button>
                        </Popover>
                    </div>
                    <div className="gen-ai-result-disable-ai-overview">
                        {isShowAIOverview() && window.location.pathname === '/results' && <>
                            <div className="genAIRecommended-main-disable-ai-overview-classSection">
                                {isDisableAIOverviewProcessing ? <img
                                    src={imsLoader}
                                    alt="Loading Data"
                                    style={{ height: "18px" }}
                                /> : <><input
                                    type="checkbox"
                                    id={`isDisableAIOverview`}
                                    value="isDisableAIOverview"
                                    name="classCheckBox"
                                    className="cname"
                                    onChange={handleOnClickIsDisableAIOverview}
                                    checked={isDisableAIOverview}
                                    class="k-checkbox"
                                    style={{ margin: "0px" }}
                                />
                                    <span onClick={handleOnClickIsDisableAIOverview} className="genAIRecommended-main-title">Document Search Only</span></>}
                            </div>
                            <div style={{ visibility: "hidden", width: "110px" }} >&nbsp;</div>
                        </>}
                    </div>
                </div>
            </div>)
    }
}